import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HomeLogoAnimationService {
  private playbackPending = true;
  private playbackSequence = 0;

  resetForLogin(): void {
    this.playbackPending = true;
  }

  takeHomeLogoSource(): string {
    // Celular: a animação toca sempre que a Home é aberta (no computador, só uma vez por login).
    const celular = typeof window !== 'undefined' && window.innerWidth <= 900;
    if (!this.playbackPending && !celular) {
      return 'assets/global-parts-home-final.webp';
    }

    this.playbackPending = false;
    this.playbackSequence += 1;
    // A fresh URL also restarts WebP playback after logout/login in the same tab.
    return `assets/global-parts-home-once.webp?play=${Date.now()}-${this.playbackSequence}`;
  }
}
